import { createIcon } from '@chakra-ui/react';

export const LockClosed = createIcon({
  displayName: 'Lock',
  viewBox: '0 0 15.711 20',
  path: (
    <path
      id="Lock-closed"
      data-name="Lock closed"
      d="M16.669,8.865h-.721V7.422a6.012,6.012,0,1,0-12.024,0V8.865H3.2A1.122,1.122,0,0,0,2.08,9.987V18A3.447,3.447,0,0,0,5.527,21.41h8.818a3.447,3.447,0,0,0,3.447-3.467V9.927A1.122,1.122,0,0,0,16.669,8.865Zm-5.892,6.874v1.583a.4.4,0,0,1-.4.4H9.455a.4.4,0,0,1-.4-.4v-1.6A1.764,1.764,0,1,1,11.7,14.2a1.784,1.784,0,0,1-.922,1.543Zm2.946-6.874H6.148V7.422a3.788,3.788,0,1,1,7.575,0Z"
      transform="translate(-2.08 -1.41)"
      fill="currentColor"
    />
  ),
});
